import { BRAND_INTERNATIONAL, OFFICIAL_SLOGAN, STORE_NAME_UA } from "../brand.js";

export const messagesUk = {
  brand: {
    name: STORE_NAME_UA,
    international: BRAND_INTERNATIONAL,
    tagline: OFFICIAL_SLOGAN,
    slogan: OFFICIAL_SLOGAN,
  },
  nav: {
    home: "Головна",
    catalog: "Каталог",
    cart: "Кошик",
    profile: "Профіль",
  },
  common: {
    retry: "Спробувати ще",
    loadMore: "Завантажити ще",
    back: "Назад",
    close: "Закрити",
    searchPlaceholder: "Пошук товарів…",
    noImage: "Без фото",
    customerFallback: "Гість",
    currency: "₴",
    soon: "Незабаром",
  },
  session: {
    connecting: "Підключення сесії…",
    unavailable: "Сесію не вдалося відкрити",
    errorTitle: "Щось пішло не так",
    telegramOnly:
      "Відкрийте застосунок у Telegram для авторизації. У браузері initData недоступний.",
  },
  home: {
    greeting: (name: string) => `Вітаємо, ${name}`,
    heroTitle: OFFICIAL_SLOGAN,
    heroSubtitle:
      "Обирайте улюблені смаки з Азії та замовляйте з доставкою Новою Поштою за кілька торкань.",
    heroCta: "Переглянути каталог",
    categoriesTitle: "Категорії",
    popularTitle: "Популярні товари",
    newTitle: "Новинки",
    promoTitle: "Акції",
    preorderTitle: "Під замовлення",
    recommendedTitle: "Рекомендуємо до замовлення",
    cartShortcut: "Перейти до кошика",
    browseCatalog: "Відкрити каталог",
    emptyCatalogHint: "Каталог оновлюється. Спробуйте пізніше або напишіть менеджеру в підтримку.",
    categoriesLoading: "Завантаження категорій…",
    categoriesEmpty: "Категорії зʼявляться після синхронізації товарів.",
    loadFailed: "Не вдалося завантажити головну сторінку.",
    trustDelivery: "Доставка Новою Поштою по Україні.",
  },
  catalog: {
    title: "Каталог",
    sortLabel: "Сортування",
    filterLabel: "Фільтр",
    sortDefault: "За замовчуванням",
    sortPriceAsc: "Ціна: зростання",
    sortPriceDesc: "Ціна: спадання",
    sortName: "За назвою",
    allCategories: "Усі категорії",
    categoryCountLabel: "категорій",
    loading: "Завантаження каталогу…",
    openingProduct: "Відкриваємо товар…",
    addToCart: "Додати в кошик",
    adding: "Додаємо…",
    added: "Додано в кошик",
    inStock: "В наявності",
    outOfStock: "Немає в наявності",
    emptyTitle: "Немає товарів у цьому фільтрі",
    emptySearchTitle: "Нічого не знайдено",
    emptyBody:
      "Спробуйте іншу категорію або скиньте фільтри — каталог не порожній.",
    emptySearchBody: "Спробуйте інший запит або скиньте фільтри.",
    emptyCategoryTitle: "У цій категорії зараз немає товарів",
    emptyCategoryBody: "Оберіть іншу категорію або відкрийте всі категорії.",
    resetFilters: "Скинути фільтри",
    showMoreCategories: "Ще",
    loadMoreFailed: "Не вдалося завантажити ще",
    catalogFailed: "Не вдалося завантажити каталог",
    priceUnresolved: "Ціна не підтверджена — додати в кошик не можна",
  },
  product: {
    backToCatalog: "← До каталогу",
    brand: "Бренд",
    category: "Категорія",
    country: "Країна",
    weightOrVolume: "Вага / обʼєм",
    stock: "Залишок",
    quantity: "Кількість",
    relatedTitle: "Разом купують",
    stickyAdd: "Додати в кошик",
    managerHelpTitle: "Потрібна допомога менеджера",
    managerHelpBody:
      "Для цього товару напишіть менеджеру в чаті бота — уточнимо наявність і ціну перед замовленням.",
    skuLabel: "Код товару",
    barcodeLabel: "Штрихкод",
    copyCode: "Копіювати",
    copied: "Скопійовано",
  },
  manager: {
    entry: "⚙️ Кабінет менеджера",
    title: "Кабінет менеджера",
    back: "← Назад",
    openPricing: "💱 Курс і ціноутворення",
    pricingSent: "Відкрито в Telegram",
    pricingFailed: "Не вдалося відкрити курс",
    systemStatusTitle: "📊 Статус системи",
    statusLoading: "Завантаження…",
    statusFailed: "Статус недоступний",
    envLabel: "Середовище",
    workerLabel: "Worker",
    catalogCountLabel: "Товарів у каталозі",
    resolvedLabel: "Ціни resolved",
    unresolvedLabel: "Ціни unresolved",
    promSyncLabel: "Prom sync",
    fxLabel: "Курс USD/UAH",
    roundingLabel: "Округлення",
  },
  cart: {
    title: "Кошик",
    itemsCount: (count: number) => `${count} поз.`,
    loading: "Завантаження кошика…",
    emptyTitle: "Кошик порожній",
    emptyBody: "Додайте товари з каталогу — оформлення займе лише кілька хвилин.",
    emptyCta: "Перейти до каталогу",
    clear: "Очистити кошик",
    checkout: "Оформити замовлення",
    checkoutUnavailable: "Оформлення тимчасово недоступне",
    remove: "Видалити",
    unitPrice: (price: string) => `${price} / од.`,
    subtotal: "Проміжний підсумок",
    discount: "Знижка",
    total: "Разом",
    priceUpdatedTitle: "Ціни оновлено",
    priceUpdatedBody: "Актуальні ціни застосовано до кошика перед оформленням.",
    stagingNote: "",
    promoTitle: "Промокод",
    promoHint: "TG50: −50 ₴ від суми від 500 ₴, один раз. Не суммується з іншими акціями.",
    promoPlaceholder: "TG50",
    promoApply: "Застосувати",
    promoRemove: "Скасувати",
    promoUnknown: "Невідомий промокод",
    promoTg50Applied: (uah: number) => `TG50 застосовано: −${uah} ₴`,
    promoTg50UnderMin: (min: number) => `TG50: потрібна сума від ${min} ₴ — знижка ще не активна`,
    promoAppliedOk: "Промокод прийнято",
    promoApplyFailed: "Не вдалося застосувати промокод",
  },
  checkout: {
    title: "Оформлення",
    backToCart: "← До кошика",
    summary: "Ваше замовлення",
    contact: "Контактні дані",
    delivery: "Доставка",
    payment: "Оплата",
    fullName: "ПІБ *",
    phone: "Телефон *",
    method: "Спосіб *",
    city: "Місто *",
    warehouse: "Відділення / поштомат *",
    address: "Адреса *",
    comment: "Коментар",
    loading: "Підготовка оформлення…",
    emptyCart: "Кошик порожній. Додайте товари перед оформленням.",
    browseCatalog: "Перейти до каталогу",
    unavailable: "Кошик недоступний",
    submit: "Підтвердити замовлення",
    submitting: "Надсилаємо…",
    confirmPriceChanges: "Підтвердити оновлені ціни",
    priceChangeTitle: "Ціни змінилися",
    priceChangeBody: "Підтвердіть актуальні ціни перед надсиланням замовлення.",
    paymentNote:
      "Онлайн-оплата доступна в магазині. Також можна оплатити за реквізитами або післяплатою у відділенні.",
    npNote:
      "Нова Пошта: оберіть місто та відділення або поштомат для доставки.",
    tg50Note:
      "Промокод TG50: −50 ₴ від суми від 500 ₴, один раз на клієнта, не суммується з іншими акціями. Підтверджує система/менеджер.",
    stagingBetaBanner: "",
    deliveryOptions: {
      nova_poshta_warehouse: "Нова Пошта — відділення",
      nova_poshta_courier: "Нова Пошта — кур'єр",
      pickup: "Самовивіз",
      other: "Інше",
    },
    paymentOptions: {
      cod: "Оплата при отриманні (узгодження з менеджером)",
      prepaid: "Передоплата (ручне підтвердження)",
      novapay: "Оплата онлайн",
      manager: "Узгодити оплату з менеджером",
    },
    successTitle: "Замовлення прийнято",
    successBody:
      "Статус: очікуємо оплату (вручну). Онлайн-еквайринг і live ТТН Нової Пошти вимкнені. Менеджер зв’яжеться для підтвердження.",
    successOrderRef: (id: string) => `Номер замовлення: ${id}`,
    successTaskRef: (id: string) => `Задача менеджера: ${id}`,
    orderNumberLabel: "Номер замовлення",
    managerTaskLabel: "Задача менеджера",
    backToCatalog: "Повернутися до каталогу",
  },
  profile: {
    title: "Профіль",
    phone: "Телефон",
    phoneMissing: "Не вказано",
    segment: "Сегмент",
    orders: "Мої замовлення",
    ordersPlaceholder: "Історія замовлень з'явиться тут незабаром.",
    favorites: "Обране",
    favoritesSoon: "Незабаром",
    recentlyViewed: "Нещодавно переглянуті",
    recentlyViewedSoon: "Незабаром",
    repeatPurchase: "Повторити замовлення",
    repeatPurchaseSoon: "Незабаром",
    deliveryAddresses: "Адреси доставки",
    deliveryAddressesSoon: "Незабаром",
    loyalty: "Бонуси та лояльність",
    loyaltySoon: "Незабаром",
    support: "Написати в підтримку",
    supportHint: "Менеджер допоможе з замовленням і доставкою.",
    social: "Соціальні мережі",
    aboutStore: "Про магазин",
    aboutStoreHint: "«Скарби Азії» — оригінальні продукти з Азії для дому, подарунків і HoReCa.",
    legal: "Правова інформація",
    legalHint: "Умови доставки, оплати та повернення доступні за запитом менеджера.",
    buildIdLabel: "Build ID",
  },
  segment: {
    new: "Новий",
    active: "Активний",
    vip: "VIP",
    at_risk: "Потребує уваги",
    churned: "Неактивний",
  },
} as const;
